import { isAgentsEnabled } from "@hightouch/lib/llm/agents-tier";
import { useAgentsTier } from "./use-agents-tier";

export const useAgentsEnabledFlag = () => {
  return isAgentsEnabled(useAgentsTier());
};
